import { useFeatureFlag, User } from 'configcat-react';
import { useAppSelector } from '../setup/hooks';
import { getUserAccount } from '../login/loginSlice';

export const FeatureToggles = {
    INCIDENT: 'incident',
    TRACKING: 'tracking',
    LSP_ADMINISTRATION: 'lspAdministration',
    SERVICE_OPTIONS: 'serviceOptions',
    OOB_INSPECTOR: 'oobInspector',
} as const;

export type FeatureTogglesType = (typeof FeatureToggles)[keyof typeof FeatureToggles];

type DefaultValue = string | boolean | number;
type DefaultValueTypeOf<T> = T extends boolean ? boolean : T extends number ? number : T extends string ? string : T;

export const useFeatureToggle = <V extends DefaultValue>(
    featureToggleId: FeatureTogglesType,
    defaultValue: V = false as V,
): { loading: boolean; value: DefaultValueTypeOf<V> } => {
    const account = useAppSelector(getUserAccount);
    const userObject = new User(account ?? 'NO_IDENTIFIER');
    const result = useFeatureFlag(featureToggleId, defaultValue, userObject);

    if (import.meta.env.MODE === 'development') {
        const trueUnlessIncident = featureToggleId !== FeatureToggles.INCIDENT;
        return { value: trueUnlessIncident as DefaultValueTypeOf<V>, loading: false };
    } else {
        return result;
    }
};
